type HydrationReport = unknown[];

export type WindowWithHydrationHooks = typeof window & {
	__ATL_HYDRATION_HOOK?: { report(...args: HydrationReport): void };
	__HYDRATION_ERRORS__?: unknown[];
};

export function initDevHydrationReporting(injectPoint: WindowWithHydrationHooks) {
	const windowWithHydrationHooks = injectPoint;
	windowWithHydrationHooks.__HYDRATION_ERRORS__ = [];
	windowWithHydrationHooks.__ATL_HYDRATION_HOOK = {
		report(...args: HydrationReport) {
			windowWithHydrationHooks.__HYDRATION_ERRORS__?.push(args);
		},
	};
}
